import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { ThemeProvider } from '@/components/theme-provider'
import { PostHogProvider, PostHogErrorBoundary } from '@/lib/posthog'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <PostHogProvider>
      <PostHogErrorBoundary fallback={<div>Something went wrong. Please refresh the page.</div>}>
        <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
          <App />
        </ThemeProvider>
      </PostHogErrorBoundary>
    </PostHogProvider>
  </StrictMode>,
)
